import {useCallback} from 'react'

import {useBottomModal} from '@defign/ui'
import {useIsomorphicLayoutEffect} from '@financial/common-hooks'
import {Action, sendAULog} from '@financial/common-logs'

import {InsuranceCompanyContactLayer} from '$components/insurance/my/detail/InsuranceCompanyContactLayer'
import InsuranceDetailButton from '$components/insurance/my/detail/InsuranceDetailButton'
import {InsuranceDetailTitleInfoItemWrapper} from '$components/insurance/my/detail/InsuranceDetailTitleInfo'
import useHash from '$hooks/insurance/useHash'
import {sendClickNlog} from '$utils/nlog'

import type {무료보험_카테고리} from '$share/constants/insurance'
import type {ValueOf} from 'next/constants'

export const InsuranceDetailTitleContactLayer = ({
    buttonText = '보험 문의',
    nClkPrefix,
    auCode,
    layerInfo,
}: {
    buttonText?: string
    nClkPrefix: string
    auCode: string
    layerInfo?: {
        orgCode?: string
        title: string
        homeUrl?: string
        serviceCenterTel?: string
        serviceCenterUrl?: string
        claimUrl?: string
        accidentReportUrl?: string
        emergencyTel?: string
        freeInsuCategory?: ValueOf<typeof 무료보험_카테고리>
    }
}) => {
    const {updateHash, isHashMatch} = useHash({
        hashId: '보험 문의 레이어',
    })

    const {open, close} = useBottomModal()

    const openCompanyContactModal = useCallback(() => {
        if (!layerInfo) {
            return
        }

        const onClose = () => {
            close()
            updateHash({hash: ''})
            sendClickNlog(`insudetail.${nClkPrefix}popx`)
        }

        open({
            children: (
                <InsuranceCompanyContactLayer
                    nClkPrefix={nClkPrefix}
                    orgCode={layerInfo.orgCode}
                    title={layerInfo.title}
                    homeUrl={layerInfo.homeUrl || ''}
                    serviceCenterTel={layerInfo.serviceCenterTel || ''}
                    serviceCenterUrl={layerInfo.serviceCenterUrl}
                    claimUrl={layerInfo.claimUrl}
                    accidentReportUrl={layerInfo.accidentReportUrl}
                    emergencyTel={layerInfo.emergencyTel}
                    freeInsuCategory={layerInfo.freeInsuCategory}
                />
            ),
            isShowCloseButton: true,
            onClickCloseButton: onClose,
            onClickDimmedLayer: onClose,
        })
    }, [close, layerInfo, nClkPrefix, open, updateHash])

    useIsomorphicLayoutEffect(() => {
        isHashMatch && setTimeout(openCompanyContactModal, 0)
    }, [isHashMatch, openCompanyContactModal])

    const handleClick = () => {
        sendClickNlog(`insudetail.${nClkPrefix}inqu`)
        sendAULog({service: 'md', page: 'insu', area: 'A', code: auCode}, Action.Click)
        openCompanyContactModal()
    }

    return (
        <InsuranceDetailTitleInfoItemWrapper>
            <InsuranceDetailButton text={buttonText} onClick={handleClick} />
        </InsuranceDetailTitleInfoItemWrapper>
    )
}
